/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum IntegrationProvider {
  Netsuite = "netsuite",
  Shopify = "shopify",
  Bigcommerce = "bigcommerce",
}

export function instanceOfIntegrationProvider(value: any): boolean {
  for (const key in IntegrationProvider) {
    if (Object.prototype.hasOwnProperty.call(IntegrationProvider, key)) {
      if (
        IntegrationProvider[key as keyof typeof IntegrationProvider] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function IntegrationProviderFromJSON(json: any): IntegrationProvider {
  return IntegrationProviderFromJSONTyped(json, false);
}

export function IntegrationProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IntegrationProvider {
  return json as IntegrationProvider;
}

export function IntegrationProviderToJSON(
  value?: IntegrationProvider | null,
): any {
  return value as any;
}

export function IntegrationProviderToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): IntegrationProvider {
  return value as IntegrationProvider;
}
